module.exports = __webpack_public_path__ + "assets/1bfb31c4307cf4a27dff94bd31cd893b.woff2";